import React from 'react';
import { map, isEqual } from 'lodash';

// local dependencies
import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';
import { Form } from 'modules/form';
import { button as Button } from 'modules/button';
import { getDisplayValue } from 'resolvers/formatValue';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { editMemberSecuritySettingsSendOtp as EditMemberSecuritySettingsSendOtp } from 'ui/views/widgets/editMemberSecuritySettingsSendOtp';
 *
 * // render
 * <EditMemberSecuritySettingsSendOtp propName='propValue'/>
 */
export const editMemberSecuritySettingsSendOtp = ( props ) => {
    
    const { actions, field, message, itemData, mode, addTitle } = props;

    return (
        <div className='ui-edit-member-security-settings-send-otp'>
            <div className='ui-edit-member-security-settings-send-otp__header'>

                {/* title for the modal */}
                <div className='ui-edit-member-security-settings-send-otp__header__title'>
                    { getLabel( addTitle ) }
                </div>

                {/* close button */}
                <div className='ui-error-overlay__head__close' onClick={ () => props.closeOverlay() }>
                    <Icon name='close' width='14' height='14' fill='#ffffff'/>
                </div>
            </div>

            <div className='ui-edit-member-security-settings-send-otp__body'>

				{/* title for the drug preference */}
                <div className='ui-edit-member-security-settings-send-otp__body__description'>
                    <div>{ message }</div>
                    <div className='ui-edit-member-security-settings-send-otp__body__description__content'>
                        <div className='ui-edit-member-security-settings-send-otp__body__description__content__title'>{ getLabel( field.title ) }</div>
                        <div className='ui-edit-member-security-settings-send-otp__body__description__content__value'>
                        { getDisplayValue( {
                                type: field.type,
                                value: itemData[ field.name ],
                            } ) }
                        </div>
                    </div>
                </div>
                    <Form
                       values={ itemData } // default values
                        isValid={ false }
                        mode={ mode }
                        onSubmit={ () => {
                            props.onSumbitClick();
                        } }>
                             { ( { onSumbit } = {} ) => {

                            return (
                                <form
                                    onSubmit={ onSumbit }
                                    className='ui-edit-member-security-settings__body__form'>
                                <div className='ui-edit-member-security-settings-send-otp__body__form__actions'>
                                    { map( actions, action => {
                                        return (
                                            <Button
                                                key={ action.name }
                                                id= { action.name }
                                                type= { 'cancel' !== action.name ? 'submit' : 'button' }
                                                { ...action }
                                                outline={ 'cancel' === action.name ? true: false }
                                                size='medium'
                                                className='ui-edit-member-security-settings__body__form__actions__action'
                                                onClick = { isEqual( 'cancel', action.name ) ?  () => props.onCancelClick() : null }/>
                                        );
                                    } ) }
                                </div>
                                </form>
                                );
                            } }
                        </Form>
			</div>
        </div>
   
    );
};

// set display name
editMemberSecuritySettingsSendOtp.displayName = 'editMemberSecuritySettingsSendOtp';

// set default props
editMemberSecuritySettingsSendOtp.defaultProps = {};

// prop types
editMemberSecuritySettingsSendOtp.propTypes = {};
